import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'decimalPoint',
    standalone: false
})
export class DecimalPointPipe implements PipeTransform {

  transform(value: any, args?: any): any {

    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return parts.join(".");
  }

}
